export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '42.0.0',
    name: 'lingo2-web',
    versionDate: '2025-06-09T11:53:48.618Z',
    gitCommitHash: '7b9ea52',
    versionLong: '42.0.0-7b9ea52',
};
export default versions;
